import { makeStyles } from 'tss-react/mui';

const useStylesImageControlsBlock: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  imageControlsBlock: {
    position: 'relative',
    zIndex: 100,
    width: '100%',
    height: '100%',
    '&:hover': {
      background: theme.palette.background.default,
      opacity: 0.5,
    },
  },
  imageControlsBlockFloating: {
    position: 'absolute',
  },
  imageControlsBlockTransparent: {
    opacity: 0,
    '&:hover': {
      opacity: 0.5,
    },
  },
  deleteImageButton: {
    top: 5,
    right: 5,
    color: theme.palette.common.white,
    background: theme.palette.error.main,
    borderRadius: '50%',
    opacity: 0.7,
    cursor: 'pointer',
  },
}));

export default useStylesImageControlsBlock;
